export default {
  isStepValid: (state) => (step) => {
    return state.validations[`step${step}`];
  },

  allStepsValid: (state) => {
    return Object.values(state.validations).every(Boolean);
  },

  getTemplateField: (state) => (field) => {
    return state.template[field];
  },

  currentStepStatus: (state) => {
    return state.validations;
  },
};